
<form [formGroup]="milestoneForm" (ngSubmit)="onCreate()">
<motif-modal-title>
  <h3 class="motif-body1-default-regular m-0">
    {{
      this.action === 'Add'
    ? this.AddMilestoneConstants.Headers.AddTitle.Name
        : this.AddMilestoneConstants.Headers.EditTitle.Name
    }}
  </h3>
  <button type="button" class="modal-close-btn" aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon
      class="motif-modal-header-close-icon"
      var="--navigation-Ic-Close-48px"
      aria-hidden="true"></motif-icon>
  </button>
</motif-modal-title>

<motif-modal-content>
    <div class="right-slide-model-wrapper">
      <div
        class="d-flex flex-column gap-4 align-items-start justify-content-start">
        <div
          class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
          <motif-form-field class="w-100">
            <label motifLabel
              >{{ this.AddMilestoneConstants.Headers.ProcessName.Name }}
              <span class="required-text"> (required)</span>
            </label>

            <input
              motifInput
              labelPosition="inside"
              type="text"
              formControlName="milestoneName"
              aria-label="Process Name"
              maxlength="150"
              [required]="true" />
          </motif-form-field>
          <div
            *ngIf="
              this.milestoneForm.get('milestoneName')?.errors &&
              this.showValidationErrors
            "
            class="sa-error-msg">
            {{ this.AddMilestoneConstants.Message.SpecialCharNotAllowed }}
          </div>
          <div class="description-char-count">
            {{ milestoneForm.get('milestoneName')?.value?.length || 0 }} / 150
          </div>
        </div>

        <div
          class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
          <motif-form-field class="w-100">
            <label motifLabel>{{
              this.AddMilestoneConstants.Headers.Description.Name
            }}</label>
            <textarea
              motifInput
              labelPosition="inside"
              type="text"
              formControlName="description"
              rows="8"
              maxlength="255"
              style="min-height: 120px"
              placeholder="Enter a description..."
              aria-label="description"></textarea>
          </motif-form-field>
          <div
            *ngIf="
              this.milestoneForm.get('description')?.errors &&
              this.showValidationErrors
            "
            class="sa-error-msg">
            {{ this.AddMilestoneConstants.Message.SpecialCharNotAllowed }}
          </div>
          <div class="description-char-count">
            {{ milestoneForm.get('description')?.value?.length || 0 }} / 255
          </div>
        </div>
        
        <div
          class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
          <motif-form-field class="w-100">
            <label motifLabel>{{
              this.AddMilestoneConstants.Headers.Deliverable.Name
              }}</label>
            <input
              motifInput
              labelPosition="inside"
              type="text"
              formControlName="deliverable"
              aria-label="deliverable" />
          </motif-form-field>
        </div>

        <div
          *ngIf="isProcessStepResolutionComplete && isProcessStepTrackingEnabled"
          class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
          <motif-form-field class="w-100">
            <label motifLabel>
              {{ this.AddMilestoneConstants.Headers.BusinessMilestone.Name }}
              <span class="required-text"> (required)</span>
            </label>
            <motif-select
              formControlName="processStep"
              [ngClass]="{ 'is-invalid': showValidationErrors && milestoneForm.get('processStep')?.invalid }"
              placeholder="Select"
              id="processStep"
              labelPosition="inside">
              <motif-option value="">Select</motif-option>
              <motif-option
                *ngFor="let step of processStepsList; let i = index"
                [value]="step.processStepGuid">
                {{ i + 1 }}. {{ step.processStepName }}
              </motif-option>
            </motif-select>
            <div
              *ngIf="showValidationErrors && milestoneForm.get('processStep')?.invalid"
              class="sa-error-msg">
              {{ this.AddMilestoneConstants.Message.BusinessMilestoneRequired }}
            </div>
          </motif-form-field>
        </div>

        <!-- <div class="d-flex flex-column gap-1 align-items-start justify-content-start w-100">
          <motif-form-field class="w-100">
            <label motifLabel>
              {{ this.AddMilestoneConstants.Headers.MilestoneOwner.Name }}
              <span class="required-text"> (required)</span>
            </label>
            <motif-select formControlName="milestoneOwner"
              [ngClass]="{'is-invalid': showValidationErrors && milestoneForm.get('milestoneOwner')?.invalid}"
              placeholder="Select" id="milestoneOwner" labelPosition="inside">
              <motif-option value="">Select</motif-option>
              <motif-option *ngFor="let user of milestoneOwnersList" [value]="user.id">
                {{ user.name }}
              </motif-option>
            </motif-select>
            <div *ngIf="showValidationErrors && milestoneForm.get('milestoneOwner')?.invalid" class="sa-error-msg">
              {{ this.AddMilestoneConstants.Message.MilestoneOwnerRequired }}
            </div>
          </motif-form-field>
        </div> -->
      </div>
    </div>
</motif-modal-content>
<motif-modal-actions>
  <button
    motifButton
    motif-modal-close
    color="secondary"
    aria-label="Cancel"
    role="button">
    {{ this.AddMilestoneConstants.ButtonTexts.CancelButton }}
  </button>

  <button
    motifButton
    color="primary"
    aria-label="Save"
    [disabled]="
      isMilestoneNameInvalid ||
      isDescriptionInvalid ||
      isProcessStepInvalid ||
      !(milestoneForm.get('milestoneName')?.value ?? '').trim()
    "
    type="submit">
    {{ this.AddMilestoneConstants.ButtonTexts.CreateButton }}
  </button>
</motif-modal-actions>
</form>